import { apiHandler } from "../buyerApiHandler";



export const createDish = (payload: any) =>
  apiHandler("post", `/dish`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const getDishes = () =>
  apiHandler("get", `/dish?include_all=true`, {
    headers: { "Content-Type": "application/json" },
  });

export const getDishById = (id: number) =>
  apiHandler("get", `/dish/${id}`, {
    headers: { "Content-Type": "application/json" },
  });

export const deleteDish = (id: number) =>
  apiHandler("delete", `/dish/${id}`, {
    headers: { "Content-Type": "application/json" },
  });

export const updateDish = (id: number, payload: any) =>
  apiHandler("patch", `/dish/${id}`, payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const updateDishSequence = (id: number, payload: any) =>
  apiHandler("patch", `/dish/${id}/move`, payload, {
    headers: { "Content-Type": "application/json" },
  });

export const normalizeDishSequence = (foodType: string = "Veg") =>
  apiHandler(
    "post",
    `/dish/normalize-sequences?food_type=${foodType}`
  );
